import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { supabase } from "./supabaseClient";

import AuthTabs from "./components/AuthTabs";
import AdminPanel from "./components/AdminPanel";
import ChatInterface from "./components/ChatInterface";
import DomainSelectionPopup from "./components/DomainSelectionPopup";

const MainRouter = ({ themeMode, onToggleTheme }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Always start with NO domain selected → forces popup
  const [domain, setDomain] = useState(null);

  const handleDomainChange = (newDomain) => {
    setDomain(newDomain);
    localStorage.setItem("selectedDomain", newDomain);
  };

  useEffect(() => {
    const init = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      setUser(user || null);
      setLoading(false);

      // ⚠️ IMPORTANT FIX:
      // Popup must ALWAYS appear on login → clear last domain
      if (user) {
        localStorage.removeItem("selectedDomain");
        setDomain(null);
      }
    };

    init();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        const authedUser = session?.user ?? null;
        setUser(authedUser);

        if (!authedUser) {
          // Reset domain on logout
          localStorage.removeItem("selectedDomain");
          setDomain(null);
        }
      }
    );

    return () => listener.subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          color: "#fff",
          textAlign: "center",
          mt: "40vh",
          fontSize: "1.2rem",
        }}
      >
        Checking authentication...
      </Box>
    );
  }

  // Not logged in → Login Page
  if (!user) {
    return <AuthTabs />;
  }

  // Admin → Admin Panel
  if (user.email === "admin@infosight.ai") {
    return <AdminPanel />;
  }

  // Normal user → Domain Selection Popup → Chat
  return (
    <>
      <DomainSelectionPopup
        open={!domain}
        onDomainSelect={(selected) => handleDomainChange(selected)}
      />

      {/* Chat component renders only AFTER domain is selected */}
      {domain && (
        <Box component="main" sx={{ height: "100vh" }}>
          <ChatInterface
            key={domain}
            themeMode={themeMode}
            onToggleTheme={onToggleTheme}
            domain={domain}
            onDomainChange={handleDomainChange}
          />
        </Box>
      )}
    </>
  );
};

export default MainRouter;
